import {FilePdf} from '@phosphor-icons/react';

export default FilePdf;